import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetFormsReportService} from './get-forms-report.service';
import {GetConfigReportService} from './get-config-report.service';

@Injectable({
  providedIn: 'root'
})
export class ReportDataService {
  constructor(private getFormsReportService: GetFormsReportService,
              private getConfigReportService: GetConfigReportService) {
  }

  /*
  ATTENTION !! changer l'ordre impact la logic dans la page site detail (colonnes datatable et filter)
   */
  getSupportListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Support',
          contentTab: 'datatableSupportList',
          dataConfig: {
            form: this.getFormsReportService.getFilterSupport(),
            groupConfigs: this.getConfigReportService.getSupportConfigs(),
            header : {
              icon: 'fal fa-shipping-fast',
              text: 'GENERIC_SHIPPINGS',
            },
            content: [
              {
                name: 'ORDER_FORM_CONTACT_NAME',
                prop: 'lastName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'ORDER_FORM_CONTACT_SURNAME',
                prop: 'firstName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_COUNT',
                prop: 'count',
                sortable: true,
                type: 'text'
              },
              {
                name: 'REPORT_SUPPORT_LIST_VECTOR',
                prop: 'vector',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_FROM_DATE',
                prop: 'fromDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_TO_DATE',
                prop: 'toDate',
                sortable: true,
                type: 'date'
              },
            ]
          },
        }
      ]
    }
  }
}


